module.exports = __webpack_public_path__ + "static/media/licenciado-sebrae-logo.ac5838b0.svg";